import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'; 
import { connect } from 'react-redux';
import axios from 'axios';

import EditModal from './EditModal';
import { FiEdit } from 'react-icons/fi';
import PerformanceChart from './PerformanceChart';
import SubmissionsChart from './SubmissionsChart';
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';
import CoinImg from '../../assets/img/coin.png';
import Spinner from '../MerchandiseStore/Spinner/Spinner';
import './Profile.css';

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            username: "",
            coins: 0,
            firstName: null,
            lastName: null,
            email: null,
            submissions: 10,
            contests: 3,
            institute: null,
            address: null,
            contact: null,
            gender: null,
            pastPerformances: null,
            pastSubmissions: null,
            loading: false
        }
    }

    callCompleteData = async () => {
        this.setState({
            loading: true
        })
        await axios.post('https://server.codeium.tech/user/profile', {
            username: this.props.username
        }).then(res => {
            const userInfo = res.data.msg[0];
            this.setState({
                username: this.props.username,
                firstName: userInfo.fname,
                lastName: userInfo.lname,
                gender: userInfo.gender,
                address: userInfo.address,
                contact: userInfo.phone_no,
                coins: userInfo.u_coins,
                institute: userInfo.inst_name,
                email: userInfo.email_id,
            })
        })
        .catch(err => {
            // console.log(err);
        })
        await axios.post('https://server.codeium.tech/contest/all', {
        username: this.props.username,
        }).then(res => {
            let temp = res.data.msg;
            if(temp.length === 1 || temp.length === 2) {
                temp.push({});
                temp.unshift({});
            }
            this.setState({
                pastPerformances: temp
            })
        })

        await axios.post('https://server.codeium.tech/submission/all', {
            username: this.props.username,
        }).then(res => {
            this.setState({
                pastSubmissions: res.data.msg,
            })
        })

        this.setState({
            loading: false
        })
    }

    componentDidUpdate(prevProps) {
        if(prevProps.username !== this.props.username && this.props.username) {
            // console.log(this.props.username);
            this.callCompleteData();
        }
    }

    componentDidMount() {
        if(this.props.username) {
            this.callCompleteData();
        }
    }

    showModalHandler = () => {
        this.setState({
            showModal: true
        })
    }

    closeModalHandler = () => {
        this.setState({
            showModal: false
        })
    }

    render() {
        return (
            <>
                <EditModal 
                    show={this.state.showModal} 
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    institute={this.state.institute}
                    address={this.state.address}
                    contact={this.state.contact}
                    gender={this.state.gender}
                    closeModal={this.closeModalHandler} 
                    coins={this.state.coins}
                    institute={this.state.institute}
                    email={this.state.email}
                />
                <Header />
                {
                    this.state.loading ? <Spinner /> : (

                        <div className=" container my-5 p-1">
                            <h1 className="primary-heading ml-1 ml-sm-0">Profile</h1>
                            <div className="row">
                                <div className="col-md-10 col-12">
                                    <div className=" tab-container p-2 p-md-3">
                                        <div className="d-flex justify-content-between">
                                            <h3>{this.state.firstName + " " + this.state.lastName}</h3>
                                            {
                                                this.state.username === this.props.username ? 
                                                <h3>
                                                    <FiEdit onClick={this.showModalHandler} className="IconButton" />
                                                </h3> : null
                                            } 
                                        </div>
                                        <hr className="mt-0 bg-dark"/>
                                        <ul class="list-group ProfileList list-group-flush mx-md-2 ">
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Username:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.username}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Email:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.email}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Coins:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.coins}
                                                    
                                                    <img src={CoinImg} className="Cart_CoinImg" />
                                                    
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Gender:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.gender ? this.state.gender : <span>&#8212;</span>}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Contact:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.contact ? this.state.contact : <span>&#8212;</span>}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Institute:
                                                </div>
                                                <div className="ListData">
                                                    {this.state.institute ? this.state.institute : <span>&#8212;</span>}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <div className="ListField">
                                                    Address
                                                </div>
                                                <div className="ListData">
                                                    {this.state.address ? this.state.address : <span>&#8212;</span>}
                                                </div>
                                            </li>
                                        </ul>
                                        <hr className="bg-dark"/>
                                        <PerformanceChart performances={this.state.pastPerformances} />
                                        <hr className="bg-dark mt-5" />
                                        <SubmissionsChart submissions={this.state.pastSubmissions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                <Footer />
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
      username: state.auth.username,
    }
}

export default connect(mapStateToProps)(Profile);